(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thistle-catalog-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLSelectElement && event.target.matches('[data-tb-category-select]')) {
      window.location.assign(event.target.value);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thistle-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thistle-footer-menu')) {
    customElements.define('thistle-footer-menu', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.updateLayout = () => {
          this.details.open = !this.mobileQuery.matches;
          this.summary.tabIndex = this.mobileQuery.matches ? 0 : -1;
          this.summary.setAttribute('aria-disabled', String(!this.mobileQuery.matches));
        };
        this.updateLayout();
        this.mobileQuery.addEventListener('change', this.updateLayout);
      }
      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.updateLayout);
      }
    });
  }

  if (!customElements.get('thistle-privacy-controls')) {
    customElements.define('thistle-privacy-controls', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        if (!this.button || !this.status) return;
        this.attempts = 0;
        this.handleClick = async () => {
          this.status.hidden = true;
          try {
            await window.privacyBanner.showPreferences();
          } catch {
            this.status.hidden = false;
          }
        };
        this.button.addEventListener('click', this.handleClick);
        this.checkAvailability();
      }

      checkAvailability() {
        if (typeof window.privacyBanner?.showPreferences === 'function') {
          this.button.hidden = false;
        } else if (this.attempts++ < 40) {
          this.timer = window.setTimeout(() => this.checkAvailability(), 250);
        }
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.button?.removeEventListener('click', this.handleClick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thistle-report-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thistle-report-library')) {
    class ThistleReportLibrary extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.form = this.querySelector('[data-report-search]');
        if (!this.form) return;
        this.initialized = true;
        this.input = this.form.querySelector('input');
        this.cards = [...this.querySelectorAll('[data-report-card]')];
        this.count = this.querySelector('[data-report-count]');
        this.empty = this.querySelector('[data-report-no-results]');
        this.form.hidden = false;
        this.form.addEventListener('submit', (event) => event.preventDefault());
        this.input.addEventListener('input', () => this.filterReports());
        this.input.addEventListener('search', () => this.filterReports());
      }
      filterReports() {
        const terms = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
        let visible = 0;
        this.cards.forEach((card) => {
          const matches = terms.every((term) => card.dataset.search.includes(term));
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        this.count.textContent = this.dataset.countLabel.replace('__COUNT__', String(visible));
        this.empty.hidden = visible > 0;
      }
    }
    customElements.define('thistle-report-library', ThistleReportLibrary);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thistle-research-enquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const revealResearch = () => {
      const target = document.getElementById('research-enquiries');
      const details = target?.querySelector('details');
      if (details) details.open = true;
    };
    const revealHashTarget = () => {
      if (window.location.hash === '#research-enquiries') {
        revealResearch();
        return;
      }
      const target = document.getElementById(window.location.hash.slice(1));
      if (!target?.matches('form.thistle-research__form')) return;
      const details = target.closest('details');
      if (details) details.open = true;
    };
    const revealResult = () => {
      document.querySelectorAll('[data-thistle-research-result]').forEach(result => {
        const details = result.closest('details');
        if (details) details.open = true;
        result.focus();
      });
      revealHashTarget();
    };
    document.addEventListener('click', event => {
      if (event.target.closest?.('[data-thistle-open-research]')) revealResearch();
    });
    window.addEventListener('hashchange', revealHashTarget);
    document.addEventListener('shopify:section:load', revealResult);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealResult, { once: true });
    else revealResult();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thistle-service"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thistle-service-disclosure')) {
    customElements.define('thistle-service-disclosure', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.mobileQuery = window.matchMedia('(max-width: 989px)');
        this.updateLayout = () => {
          this.details.open = !this.mobileQuery.matches;
          this.summary.tabIndex = this.mobileQuery.matches ? 0 : -1;
          this.summary.setAttribute('aria-disabled', String(!this.mobileQuery.matches));
        };
        this.updateLayout();
        this.mobileQuery.addEventListener('change', this.updateLayout);
      }
      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.updateLayout);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
